import errorFillIcon from 'assets/icons/svg/icon/error-fill.svg';
import svgSearch from 'assets/icons/svg/icon/Search.svg';

import googlemapSearch from 'assets/icons/svg/icon/googlemap-search.svg';
import googlemapPosition from 'assets/icons/svg/icon/googlemap-pos.svg';
import ku from 'assets/icons/svg/icon/ku.svg';
import voucher from 'assets/icons/svg/icon/voucher.svg';
import refreshIcon from 'assets/icons/svg/icon/refresh_icon.svg';
import iphoneIcon from 'assets/icons/svg/icon/icon_phone.svg';

export default {
  'app:errorFillIcon': `img:${errorFillIcon}`,
  'app:svgSearch': `img:${svgSearch}`,

  'app:googlemapSearch': `img:${googlemapSearch}`,
  'app:googlemapPosition': `img:${googlemapPosition}`,
  'app:ku': `img:${ku}`,
  'app:voucher': `img:${voucher}`,
  'app:refresh_icon': `img:${refreshIcon}`,
  'app:iphone_icon': `img:${iphoneIcon}`
};
